'use strict';
// Native Shopify bundles own the price and deduct the four components.
window.adventCheckout = async function (items, giftCard) {
  if (window.ADVENT_CHECKOUT_READY !== true) throw new Error('Salget er endnu ikke åbnet.');
  if (window.ADVENT_MARKET?.country !== 'DK' || window.ADVENT_MARKET?.currency !== 'DKK') {
    throw new Error('Kalenderen kan kun købes på den danske shop i DKK.');
  }
  if (!Array.isArray(items) || !items.length || giftCard) throw new Error('Kontrollér venligst din kurv.');
  const map = window.ADVENT_BUNDLES;
  if (!map) throw new Error('Kalenderens varianter kunne ikke indlæses.');
  const lines = await Promise.all(items.map(async item => {
    if (!Array.isArray(item.items) || item.items.length !== 4 || !Number.isSafeInteger(item.qty) || item.qty < 1 || typeof item.group !== 'string' || !item.group) {
      throw new Error('Vælg præcis fire smykker.');
    }
    const pieces = item.items.map(get);
    if (pieces.some(p => !p || p.needsSize || p.available !== true) || new Set(pieces.map(p => p.family)).size !== 4) {
      throw new Error('Kontrollér lager og eventuel længde på dine fire smykker.');
    }
    const key = pieces.map(p => p.variantId).sort().join(',');
    let id;
    if (item.type === 'build') {
      if (!window.AdventBuilderPricing || !window.ADVENT_BUILD_INDEX) throw new Error('Kalenderens pris kunne ikke indlæses. Prøv igen.');
      let verified;
      try { verified = await window.AdventBuilderPricing.resolve(pieces, 'DK', {fresh:true}); }
      catch (_) { throw new Error('Kalenderens pris kunne ikke bekræftes. Genindlæs siden og vælg igen.'); }
      if (Math.round(Number(item.price) * 100) !== verified.cents) throw new Error('Kalenderens pris har ændret sig. Genindlæs siden og vælg igen.');
      id = verified.variantId;
    } else id = map.fixed[item.type]?.key === key ? map.fixed[item.type].variantId : null;
    if (!id) throw new Error('Denne kombination er endnu ikke tilgængelig. Vælg igen.');
    return {
      id, quantity: item.qty,
      properties: {
        _advent_2026: 'true', _advent_group: item.group,
        ...Object.fromEntries(Object.entries(window.AdventAttribution?.properties?.() || {}).map(([key,value]) => ['_'+key,value])),
        Kalender: labels[item.type],
        Pakning: '4 sorte smykkeæsker med bånd · numre 1–4 under bunden',
        ...Object.fromEntries(pieces.map((p, i) => ['Advent ' + (i + 1), p.name + ' · ' + p.sku + (p.baseId ? ' · ' + p.size : '')]))
      }
    };
  }));
  const cartResponse = await fetch('/cart.js', {headers: {Accept: 'application/json'}});
  if (!cartResponse.ok) throw new Error('Kurven kan ikke hentes lige nu. Prøv igen.');
  const current = await cartResponse.json();
  const updates = {};
  // Reconcile only Advent lines. Ordinary jewellery in the Shopify cart stays untouched.
  for (const existing of current.items) {
    if (existing.properties?._advent_2026 === 'true' && existing.properties?._advent_group &&
        !lines.some(line => String(existing.variant_id) === String(line.id) && existing.properties._advent_group === line.properties._advent_group)) {
      updates[existing.key] = 0;
    }
  }
  const missing = lines.filter(line => {
    const existing = current.items.find(existing => String(existing.variant_id) === String(line.id) && existing.properties?._advent_group === line.properties._advent_group);
    if (existing && existing.quantity !== line.quantity) updates[existing.key] = line.quantity;
    return !existing;
  });
  if (missing.length) {
    const response = await fetch('/cart/add.js', {
      method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: missing})
    });
    if (!response.ok) {
      if (response.status === 422) throw new Error('Mindst ét smykke er ikke længere på lager i det valgte antal. Tilpas din kalender.');
      throw new Error('Kurven kunne ikke opdateres. Prøv igen.');
    }
  }
  const marked = await fetch('/cart/update.js', {
    method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
    body: JSON.stringify({updates, attributes: {Adventskalender: '2026', ...window.AdventAttribution?.properties?.(), 'Advent pakning': '4 smykkeæsker med sorte bånd pr. kalender. Nummerér under bunden 1–4 efter Advent-felterne på kalenderlinjen.'}})
  });
  if (!marked.ok) throw new Error('Kalenderen ligger i kurven, men pakkeoplysningerne blev ikke gemt. Prøv igen.');
  location.assign('/checkout');
};
